import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class KantoorLoginService {
    public constructor(private router: Router) {}

    public navigateToBrowserPage(): void {
        this.router.navigate(['browser']);
    }
}
